<template>
    <custom-search
        :label="label"
        :display-value="itemCurrent.name"
        :disabled="!enabled"
        placeholder="Buscador de productos"
        :fetch-items="searchInventoryItems"
        @select="onSelect"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
        <template #item="{ item }">
            <span class="flex justify-between">
                <span>{{ item.name | cut(50) }}</span>
                <span>{{ item.priceOffer | money }}</span>
            </span>
        </template>
    </custom-search>
</template>

<script>
import { mapActions, mapState } from "vuex";

import CustomSearch from "@/components/utils/CustomSearch.vue";

export default {
    name: "InventoriesSearch",
    components: {
        CustomSearch
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        defaultFilters: {
            default: () => ({
                active: true
            }),
            type: Object,
            required: false
        },
        itemCurrent: {
            default: () => ({ name: "" }),
            type: Object,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    computed: {
        ...mapState("commons", ["selectedMerchant"])
    },
    methods: {
        ...mapActions("inventories", ["listAllInventories"]),
        searchInventoryItems(keyword, required = false) {
            return this.listAllInventories({
                ...this.defaultFilters,
                merchantType: this.selectedMerchant.merchantType,
                merchantId: this.selectedMerchant.merchantId,
                keyword,
                required
            });
        },
        onSelect(item) {
            this.$emit("input", item);
        }
    }
};
</script>
